import React, {Component} from "react";
import "./InquiryTable.css"
import InquiryHeader from "../InquiryHeader/InquiryHeader";
import InquiryRow from "../InquiryRow/InquiryRow";
import InquiryBottom from "../InquiryBottom/InquiryBottom";
import {RESOURCE_BASE_URL, ITEM_COUNT_PER_PAGE, BASE_URL} from "../../../../configuration";
import axios from 'axios';
import EmptyRecords from "../EmptyRecords";
import {FormattedMessage} from "react-intl";

class InquiryTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: props.userId,
            inquiries: [],
            totalItemCount: 0,
            activePage: 1
        };

        this.getUserInquiries = this.getUserInquiries.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        // console.log("inquiry table");
        if (this.props.userId !== "") {
            // this.handlePageChange(this.state.activePage);
            this.getUserInquiries(0, ITEM_COUNT_PER_PAGE);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.getInquiries !== this.props.getInquiries){
            console.log("GETTING INQURIES ========");
            this.getUserInquiries(0, ITEM_COUNT_PER_PAGE);
        }
    }

    handlePageChange = (pageNumber) => {

        this.setState({activePage: pageNumber},()=>this.getUserInquiries(this.state.activePage-1, ITEM_COUNT_PER_PAGE));
        // let offset = (pageNumber-1) * ITEM_COUNT_PER_PAGE;

    };

    getUserInquiries = (offset, limit) => {

        // console.log("users123445423525wfw",this.props.userId);
        axios.get(RESOURCE_BASE_URL + 'api/users/' + localStorage.getItem('userId') +
            '/inquiries?offset=' + offset + '&limit=' + limit )
            .then((res) => {
                this.setState({
                    inquiries: res.data.inquiries.content,
                    totalItemCount: res.data.rowCount
                });
                // console.log(res.data);
            })
            .catch((err) => {
                this.setState(
                    {
                        inquiries: []
                    });
                console.log("[API] ERROR: ", err);
                console.log("Token invalid");
                localStorage.clear();
                window.location.replace(BASE_URL + "login");
            });
    };

    render() {
        // console.log("INQUIRY TABLE INQ===>", this.state.inquiries);
        let noRecords;
        let inqList = this.state.inquiries.length;
        if (inqList ===0) {
            noRecords = <EmptyRecords />;
        }
        let index=1;

        return (
            <div>
                {this.state.inquiries.length===0 ?
                    <div className="container-fluid ">
                        <div className="row text-center ">
                            <br/>
                            お問い合わせ履歴がございません。
                            {/*<hr/>*/}
                        </div>
                    </div>:
                    <div>
                        <InquiryHeader/>
                        <hr className="resp-header-hr"/>
                        {this.state.inquiries.map(inquiry => {
                            return <InquiryRow key={inquiry.id} inquiry={inquiry} index={index++}
                                               getUserInquiries={this.getUserInquiries}/>;

                        })}
                        {noRecords}

                        <InquiryBottom activePage={this.state.activePage}
                                       itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                       totalItemsCount={this.state.totalItemCount}
                                       handlePageChange={this.handlePageChange} />
                    </div>
                }


            </div>
        )
    }
}

export default InquiryTable;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/InquiryTable/InquiryTable.js